import { Controller } from "stimulus";
import Ping from "ping.js";

export default class extends Controller {
  static get targets() {
    return ["central"];
  }

  connect() {
    setInterval(this.ping, 10000);
  }

  ping = () => {
    let p = new Ping();
    let central = this.centralTarget;
    p.ping("https://github.com", function(err, data) {
      // if (err) {
      //   console.log("error loading resource");
      //   data = data + " " + err;
      // }
      central.innerHTML = `${data} ms`;
    });
  }
}
